import { NOTIFICATION_EVENT_TYPE } from "src/shared/config/src";
import LocalImages from "./../../static";
import { AppRoutes } from "src/app/navigation/routes";
import { URL_CONSTANTS } from "src/app/config/appConstants";
import { toast } from "react-toastify";

export const eventTypeImages = new Map([
    [NOTIFICATION_EVENT_TYPE.INVOICE_SENT, LocalImages.invoiceIcon],
    [NOTIFICATION_EVENT_TYPE.OBSERVATION_PUSLISHED, LocalImages.observationIcon],
    [NOTIFICATION_EVENT_TYPE.OBSERVATION_COMMENT_ADDED, LocalImages.observationIcon],
    [NOTIFICATION_EVENT_TYPE.DD_SHARED, LocalImages.diaryIcon],
    [NOTIFICATION_EVENT_TYPE.DD_PUBLISHED, LocalImages.diaryIcon],
    [NOTIFICATION_EVENT_TYPE.ACCIDENT_SHEET_CREATED, LocalImages.accidentSheetIcon],
    [NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_CREATED, LocalImages.medicineFormNotiIcon],
    [NOTIFICATION_EVENT_TYPE.OBSERVATION_LOVED, LocalImages.observationIcon],
    [NOTIFICATION_EVENT_TYPE.ACCIDENT_SHEET_COMPLETED, LocalImages.accidentSheetIcon],
    [NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_REJECTED, LocalImages.medicineFormNotiIcon],
    [NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_APPROVED, LocalImages.medicineFormNotiIcon],
    [NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_SUBMITTED, LocalImages.medicineFormNotiIcon],
    [NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_DOSE_PUBLISHED, LocalImages.medicineFormNotiIcon],
    [NOTIFICATION_EVENT_TYPE.SUMMATIVE_REPORT_PUBLISHED, LocalImages.reportsIcon],
    [NOTIFICATION_EVENT_TYPE.TRANSITION_REPORT_PUBLISHED, LocalImages.reportsIcon],
    [NOTIFICATION_EVENT_TYPE.CUSTOM_SUMMATIVE_REPORT_PUBLISHED, LocalImages.reportsIcon],
    [NOTIFICATION_EVENT_TYPE.CUSTOM_TRANSITION_REPORT_PUBLISHED, LocalImages.reportsIcon],
    [NOTIFICATION_EVENT_TYPE.PLANNING_SHEET, LocalImages.planningSheetIcon],
    [NOTIFICATION_EVENT_TYPE.PROGRESS_CHECK_REPORT_PUBLISHED, LocalImages.reportsIcon],
    [NOTIFICATION_EVENT_TYPE.DOCUMENT_ADDED, LocalImages.documentIcon],
    [NOTIFICATION_EVENT_TYPE.MESSAGE_RECEIVED, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.EYENGAGE_POST_PUBLISHED, LocalImages.eyengageIcon],
    [NOTIFICATION_EVENT_TYPE.EYENGAGE_COMMENT_ADDED, LocalImages.eyengageIcon],
    [NOTIFICATION_EVENT_TYPE.EYENGAGE_POST_REMINDER, LocalImages.eyengageIcon],
    [NOTIFICATION_EVENT_TYPE.SIGN_IN_OUT_ADDED, LocalImages.signInOutIcon],
    [NOTIFICATION_EVENT_TYPE.INSTANT_BOOKING_CONFIRMATION, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.APPROVAL_BOOKING_REQUEST, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.APPROVAL_BOOKING_CONFIRMATION, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.APPROVAL_BOOKING_CANCELLATION, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.INVOICE_STATEMENT_SENT, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.TRANSACTION_STATEMENT_SENT, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.MESSAGES_SENT, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.PROFILE_FORM_SENT, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.PAYMENT_RECEIPT, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.DEBTORS_LETTER_SENT, LocalImages.messageIcon],
    [NOTIFICATION_EVENT_TYPE.CONVERSATION_MESSAGE_RECEIVED, LocalImages.messageIcon],
]);

export const navigateToTimelineScreen = (navigate: any, qp?: string) => {
    navigate(`${AppRoutes.TIMELINE}${qp ? `?${qp}` : ""}`);
};

export const navigateToDailyDiaryDetailScreen = (navigate: any, entityId: number, entityDetails?: string) => {
    if (entityDetails) {
        const parsedData = JSON.parse(entityDetails);
        const date = parsedData.date;
        if (date) {
            navigate(AppRoutes.DAILY_DIARY_DETAILS_SCREEN(date));
        } else {
            navigateToTimelineScreen(navigate);
        }
    } else {
        navigateToTimelineScreen(navigate);
    }
};

export const navigateToPlanningScreen = (navigate: any, entityDetails?: string) => {
    if (entityDetails) {
        const parsedData = JSON.parse(entityDetails);
        const date = parsedData.date;
        if (date) {
            navigate(`${AppRoutes.PLANNING}?${URL_CONSTANTS.FROM}=${date}`);
        } else {
            navigateToTimelineScreen(navigate);
        }
    } else {
        navigateToTimelineScreen(navigate);
    }
};

export const showToastMessage = () => {
    return toast.info("Please download eyparent mobile app from play store or app store to view this information", { autoClose: 5000 });
}

export const handleNavigationFromNotifications = (navigate: any, eventType: string, entityId: number, entityDetails?: string) => {
    switch (eventType) {
        case NOTIFICATION_EVENT_TYPE.INVOICE_SENT:
            navigate(AppRoutes.INVOICE);
            break;
        case NOTIFICATION_EVENT_TYPE.OBSERVATION_PUSLISHED:
            navigate(AppRoutes.OBSERVATION_DETAILS_SCREEN(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.OBSERVATION_COMMENT_ADDED:
            navigate(AppRoutes.OBSERVATION_DETAILS_SCREEN(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.DD_SHARED:
            navigateToDailyDiaryDetailScreen(navigate, entityId, entityDetails);
            break;
        case NOTIFICATION_EVENT_TYPE.DD_PUBLISHED:
            navigateToDailyDiaryDetailScreen(navigate, entityId, entityDetails);
            break;
        case NOTIFICATION_EVENT_TYPE.ACCIDENT_SHEET_CREATED:
            navigate(AppRoutes.ACCIDENT_SHEET_DETAILS_SCREEN(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_CREATED:
            navigate(AppRoutes.MEDICINE_FORM_DETAILS(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.OBSERVATION_LOVED:
            navigate(AppRoutes.OBSERVATION_DETAILS_SCREEN(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.ACCIDENT_SHEET_COMPLETED:
            navigate(AppRoutes.ACCIDENT_SHEET_DETAILS_SCREEN(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_REJECTED:
            navigate(AppRoutes.MEDICINE_FORM_DETAILS(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_APPROVED:
            navigate(AppRoutes.MEDICINE_FORM_DETAILS(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_SUBMITTED:
            navigate(AppRoutes.MEDICINE_FORM_DETAILS(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.MEDICINE_FORM_DOSE_PUBLISHED:
            navigate(AppRoutes.MEDICINE_FORM_DETAILS(entityId.toString()));
            break;
        case NOTIFICATION_EVENT_TYPE.SUMMATIVE_REPORT_PUBLISHED:
            navigateToTimelineScreen(navigate, `${URL_CONSTANTS.ACTIVITY_TYPE}=REPORT`);
            break;
        case NOTIFICATION_EVENT_TYPE.TRANSITION_REPORT_PUBLISHED:
            navigateToTimelineScreen(navigate, `${URL_CONSTANTS.ACTIVITY_TYPE}=REPORT`);
            break;
        case NOTIFICATION_EVENT_TYPE.CUSTOM_SUMMATIVE_REPORT_PUBLISHED:
            navigateToTimelineScreen(navigate, `${URL_CONSTANTS.ACTIVITY_TYPE}=REPORT`);
            break;
        case NOTIFICATION_EVENT_TYPE.CUSTOM_TRANSITION_REPORT_PUBLISHED:
            navigateToTimelineScreen(navigate, `${URL_CONSTANTS.ACTIVITY_TYPE}=REPORT`);
            break;
        case NOTIFICATION_EVENT_TYPE.PLANNING_SHEET:
            navigateToPlanningScreen(navigate, entityDetails);
            break;
        case NOTIFICATION_EVENT_TYPE.PROGRESS_CHECK_REPORT_PUBLISHED:
            navigateToTimelineScreen(navigate, `${URL_CONSTANTS.ACTIVITY_TYPE}=REPORT`);
            break;
        case NOTIFICATION_EVENT_TYPE.DOCUMENT_ADDED:
            navigate(AppRoutes.RESOURCES_DOCUMENTS);
            break;
        case NOTIFICATION_EVENT_TYPE.MESSAGE_RECEIVED:
            showToastMessage();
            break;
        case NOTIFICATION_EVENT_TYPE.EYENGAGE_POST_PUBLISHED:
            navigate(`${AppRoutes.EYENGAGE_POST_DETAILS}/${entityId}`);
            break;
        case NOTIFICATION_EVENT_TYPE.EYENGAGE_COMMENT_ADDED:
            navigate(`${AppRoutes.EYENGAGE_POST_DETAILS}/${entityId}`);
            break;
        case NOTIFICATION_EVENT_TYPE.EYENGAGE_POST_REMINDER:
            navigate(`${AppRoutes.EYENGAGE_POST_DETAILS}/${entityId}`);
            break;
        case NOTIFICATION_EVENT_TYPE.SIGN_IN_OUT_ADDED:
            showToastMessage();
            break;
        case NOTIFICATION_EVENT_TYPE.INSTANT_BOOKING_CONFIRMATION:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.APPROVAL_BOOKING_REQUEST:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.APPROVAL_BOOKING_CONFIRMATION:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.APPROVAL_BOOKING_CANCELLATION:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.INVOICE_STATEMENT_SENT:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.TRANSACTION_STATEMENT_SENT:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.MESSAGES_SENT:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.PROFILE_FORM_SENT:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.PAYMENT_RECEIPT:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.DEBTORS_LETTER_SENT:
            // showToastMessage();
            navigate(`${AppRoutes.COMMUNICATIONS}`);
            break;
        case NOTIFICATION_EVENT_TYPE.CONVERSATION_MESSAGE_RECEIVED:
            showToastMessage();
            break;
        default:
            break;
    }
};
